import SessionTypeModal from './session-type-modal-view';

export default SessionTypeModal;
